import { useState } from "react";
import axios from "axios.js";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";

// @mui icons

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "app/user/components/BasicLayout";

// Images
// import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import bgImage from "assets/images/tech_bg.jpg";

import { useIsAuthenticated } from "react-auth-kit";
import {
  Snackbar,
  TextField,
  Alert,
  Backdrop,
  CircularProgress,
  Divider,
} from "@mui/material";
// import { LoadingButton } from "@mui/lab";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";

function ForgotPwd() {
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  if (isAuthenticated()) {
    navigate("/dashboard");
  }
  usePageTitle("Forgot Password");

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [emailAddress, setEmailAddress] = useState(null);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [lastSubmit, setLastSubmit] = useState(0);

  async function handleFormSubmit() {
    const now = Date.now();

    if (now - lastSubmit < 5000) {
      setErrMsg("Wait a few moments and try again.");
      setSeverity("error");
      setOpen(true);
      return false;
    }
    setLastSubmit(now);
  
    if (!emailAddress) {
      setErrMsg("Email address required.");
      setSeverity("error");
      setOpen(true);
      return false;
    }

    setShowLoading(true);
    try {
      const json = { email_address: emailAddress };
      const response = await axios.post("agents/forgot-password.json", json);
      if (response.data.status === "error") {
        setOpen(true);
        setShowLoading(false);
        setErrMsg(response.data.data.message);
        setSeverity("error");
      } else {
        setOpen(true);
        setShowLoading(false);
        setErrMsg(response.data.data.message);
        setSeverity("success");
      }
    } catch (e) {
      setShowLoading(false);
      setErrMsg("An error occurred. Please try again later.");
      setSeverity("error");
      setOpen(true);
    }
  }

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox mb={1} p={1} align="center" mt={1}>
          <MDTypography variant="h4" fontWeight="medium" mt={1}>
            {AppConfig.app_name}
          </MDTypography>
          <MDTypography display="block" variant="button" my={1}>
            Forgot Password?
          </MDTypography>
        </MDBox>
        <MDBox mb={1}>
          <Divider />
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={showLoading}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={handleClose}
              severity={severity}
              sx={{ width: "100%" }}
            >
              {errorMsg}
            </Alert>
          </Snackbar>
          <MDBox role="form">
            <MDBox mb={2}>
              <TextField
                fullWidth
                size="small"
                type="email"
                name="email"
                label="Email"
                variant="outlined"
                onChange={(e) => setEmailAddress(e.target.value)}
                sx={{ mb: 3 }}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                variant="gradient"
                color={AppConfig.sidenav_active_menu_color}
                onClick={() => handleFormSubmit()}
                fullWidth
              >
                Reset Password
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Already have an account?{" "}
                <MDTypography
                  component={Link}
                  to="/user/sign-in"
                  variant="button"
                  color={AppConfig.sidenav_active_menu_color}
                  fontWeight="medium"
                  textGradient
                >
                  Sign In
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default ForgotPwd;
